import React from "react";
import { useNavigate } from "react-router";
import { BadgeDollarSign, Car, Users, Settings2, Power, Menu } from "lucide-react";

import { auth } from "../../firebase/firebase";
import { useNotification } from "../../contexts/NotificationContext";

const menuItems = [
  {
    label: "Clientes",
    icon: Users,
    href: "/admin-management/others/clients",
    color: "bg-primary",
  },
  {
    label: "Motoristas",
    icon: Menu,
    href: "/admin-management/others/drivers",
    color: "bg-white/10",
  },
  {
    label: "Veículos",
    icon: Car,
    href: "/admin-management/others/vehicles",
    color: "bg-white/10",
  },
  {
    label: "Tabela de preços",
    icon: BadgeDollarSign,
    href: "/admin-management/others/pricing",
    color: "bg-white/10",
  },
  {
    label: "Ajustes",
    icon: Settings2,
    href: "/admin-management/others/settings",
    color: "bg-white/5",
  },
];

export default function OthersScreen() {
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const handleSignOut = () => {
    auth.signOut().then(() => {
      showNotification("info", "Você se desconectou de sua conta.");
      navigate("/");
    });
  };

  return (
    <div className="flex min-h-[calc(100vh-16rem)] flex-col justify-between space-y-3">
      <div className="space-y-3">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              onClick={() => navigate(item.href)}
              className={`flex w-full items-center justify-between rounded-3xl px-4 py-3 text-left text-white shadow-inner ${item.color}`}
            >
              <div className="flex items-center gap-3">
                <Icon className="h-5 w-5" />
                <span className="text-lg font-semibold">{item.label}</span>
              </div>
              <span className="text-xs uppercase tracking-[0.4em] text-white/70">
                Abrir
              </span>
            </button>
          );
        })}
      </div>
      <button
        onClick={handleSignOut}
        className="flex w-full items-center justify-between rounded-3xl bg-destructive px-4 py-3 text-left font-semibold text-destructive-foreground"
      >
        <div className="flex items-center gap-3">
          <Power className="h-5 w-5" />
          Sair
        </div>
        <span className="text-xs uppercase tracking-[0.4em]">Logout</span>
      </button>
    </div>
  );
}
